import * as yup from "yup";
import API from "utils/API";
import { useForm } from "react-hook-form";
import parseMoney from "utils/parseMoney";
import { DialogProps } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";

const useEditLoanAmount = (
  endpoint: string,
  onClose?: Pick<DialogProps, "onClose">["onClose"]
) => {
  const schema = yup.object().shape({
    newLoanAmount: yup
      .string()
      .required("Request loan amount is required.")
      .test(
        "betweenAmount",
        "Loan Amount should be between $25,000 - $250,000",
        (value) => {
          if (!value) return true;
          const amount = parseMoney(value);
          if (amount < 25_000 || amount > 250_000) return false;
          return true;
        }
      ),
  });

  const form = useForm<{ newLoanAmount: string }>({
    resolver: yupResolver(schema),
  });

  const [error, setError] = useState<string>();

  const onSubmit = form.handleSubmit(async (data) => {
    const response = await API.post({
      url: endpoint,
      method: "PUT",
      data: { amount: parseMoney(data.newLoanAmount) },
    });
    if ("error" in response) {
      setError(response.error);
    } else {
      onClose?.({}, "backdropClick");
    }
  });

  return {
    ...form,
    error,
    onSubmit,
  };
};

export default useEditLoanAmount;
